module.exports = __webpack_public_path__ + "static/media/img_phone-dark-half.e284007a.png";